import React, { TableRow, TableCell, IconButton, Collapse, Box, Typography, Grid, TextField, Button } from '@mui/material';
import { useState } from 'react';
import { DoNotDisturb, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { PartnerRowProps } from './PartnerRowProps';

export const PartnerRow = ({ row }: PartnerRowProps) => {
	const [open, setOpen] = useState(false);
	return (
		<>
			<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
				<TableCell colSpan={1}>
					<IconButton aria-label='expand row' size='small' onClick={() => setOpen(!open)}>
						{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
					</IconButton>
				</TableCell>
				<TableCell colSpan={2} component='th' scope='row'>
					{row.email}
				</TableCell>
				<TableCell colSpan={1}>{row.firstName}</TableCell>
				<TableCell colSpan={1}>{row.lastName}</TableCell>
				<TableCell colSpan={1}>{row.mentor ? `${row.mentor?.firstName} ${row.mentor?.lastName}` : 'N/A'}</TableCell>
				<TableCell colSpan={1}>{row.phoneNumber}</TableCell>
				<TableCell colSpan={1}>{row.country}</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
					<Collapse in={open} timeout='auto'>
						<Box sx={{ margin: 2 }}>
							<Typography variant='h6' gutterBottom component='div'>
								Partner Details
							</Typography>
							<Grid container>
								<Grid item xs={12}>
									<Grid container spacing={2}>
										<Grid item xs={12}>
											<TextField fullWidth size='small' label='Email' value={row.email} disabled />
										</Grid>
										<Grid item xs={6}>
											<TextField fullWidth size='small' label='First name' value={row.firstName} disabled />
										</Grid>
										<Grid item xs={6}>
											<TextField fullWidth size='small' label='Last name' value={row.lastName} disabled />
										</Grid>
										<Grid item xs={12}>
											<TextField fullWidth size='small' label='Address' value={row.addressLine} disabled />
										</Grid>
										<Grid item xs={6}>
											<TextField fullWidth size='small' label='Zip Code' value={row.zipCode} disabled />
										</Grid>
										<Grid item xs={6}>
											<TextField fullWidth size='small' label='City' value={row.city} disabled />
										</Grid>
										<Grid item xs={6}>
											<TextField fullWidth size='small' label='Phone' value={row.phoneNumber} disabled />
										</Grid>
										<Grid item xs={6}>
											<TextField fullWidth size='small' label='Country' value={row.country} disabled />
										</Grid>
										<Grid item xs={10}></Grid>
										<Grid item xs={2}>
											<Button fullWidth color='error' variant='contained' onClick={() => alert('Not implemented yet')}>
												<DoNotDisturb />
											</Button>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}
